$shm_hitalama_map_widget_float_code_css $shm_hitalama_map_widget_float_code
	Overlay null
	auto /
		^
		<= attach null
	textarea_hint \css
